import React, {Component} from 'react';
import Popup from "../../../components/popup";

import { ButtonCancel, ButtonProceed, ButtonReturn } from '../../../components/buttons';

import PopupContext from '../../../context/context-popup';
import Container from '../../../layouts/containers/container';
import InputsTextarea from '../../../components/inputs/inputs-text-area';

import List from '../../../components/list';
import meetingsApi from '../../../lib/meetings/meetings-api';
import alertManager from '../../../managers/alert/alert-manager';
import LabelContainer from '../../../components/label-container';
import ErrorContainer from '../../../components/error-container';
import Cross from '../../../components/buttons/cross';
import companiesApi from '../../../lib/companies/companies-api';
import ContentDropdown from '../../../components/content-dropdown';
import Row from '../../../components/row';

export default class PopupsCancelMembership extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        companiesApi.quoteCancelMembership(this.props.company?.id, {
            membership_id: this.props.membership?.id
        }).then(({ data }) => {
            this.setState({ quote: data });
        });
    }

    cancel() {
        companiesApi.cancelMembership(this.props.company?.id, {
            membership_id: this.props.membership?.id
        }).then(() => {
            this.props?.getMemberships();
            this.context.closePopup();
        })
    }

    render() {
        const { closePopup } = this.context;

        const affectedBookings = this.state.quote?.bookings_affected;

        return (
            <Popup className="booking-cancel">
                <Popup.Content>
                    <Container.Text fontSize="30px" color="#151515">Are you sure you wish to cancel this membership?</Container.Text>

                    { affectedBookings?.length > 0 && <Container.Text fontSize="16px" color="#151515">There will be a total of { this.state.quote?.total_bookings_affected } bookings affected</Container.Text> }
                    { this.state.quote?.total_difference > 0 && <Container.Text fontSize="16px" color="#151515">Cancelling this membership will incur an additional <b>£{this.state.quote?.total_difference?.toFixed(2) }</b> charge</Container.Text> }

                    { affectedBookings?.length > 0 && <ContentDropdown title="Affected Bookings">
                        <List gap="20px">
                            { affectedBookings?.map((booking, index) => {
                                let location = ``;
                                let type = ``;

                                if (booking?.booking_type === 'meeting_room') {
                                    location = `/mydmc/bookings/${booking?.booking?.id}`;
                                    type = 'Meeting Room';
                                }

                                if (booking?.booking_type === 'co_working') {
                                    location = `/mydmc/co-working/${booking?.booking?.id}`;
                                    type = 'Co Working Space';
                                }

                                return (
                                    <Row key={index} gap="20px" justifyContent="space-between" alignItems="center">
                                        <List gap='5px'>
                                            <Container.Text fontSize="16px">{ type }</Container.Text>
                                            <Container.Text fontSize="14px" color="#929BA8">{ stringToFriendlyDatetime(booking?.booking?.day || booking?.booking?.start) } - Credits: { booking?.total_credits_used } - Total: £{ booking?.original_total || 0 } -> £{ booking?.total}</Container.Text>
                                        </List>
                                        <ButtonProceed mobile onClick={() => window.location.href = location}/>
                                    </Row>
                                )
                            }) }
                        </List>
                    </ContentDropdown> }
                </Popup.Content>

                <Popup.Buttons>
                    <ButtonProceed fill onClick={this.cancel.bind(this)}>Confirm Cancellation</ButtonProceed>
                    <ButtonReturn fill onClick={closePopup} rightIcon={<Cross/>}>Return</ButtonReturn>
                    <ButtonProceed fill onClick={() => window.location.href = `/mydmc/messages`}>Contact Us</ButtonProceed>
                </Popup.Buttons>
            </Popup>
        );
    }
}
